import Column from "theme/layouts/Column";
import Div from "theme/layouts/Div";
import NewsletterSignup from "./NewsletterSignup";
import PropTypes from "prop-types";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import Waterfall from "theme/layouts/Waterfall";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import { useSelector } from "react-redux";

const Newsletter = ({ isFooter, ...rest }) => {
    const newsletter = useSelector(({ footer }) => footer.data?.newsletter?.data?.data) || {};

    const { heading, subheading, consent_text: consentText, newsletter_form: newsletterForm } = newsletter || {};

    const { email_input: emailInput, form } = newsletterForm || {};

    return (
        <Div as="section" {...rest}>
            <Column gap="48px">
                <Waterfall rowGap={["12px", null, null, null, "16px"]}>
                    {heading && (
                        <TextStyles as="h2" textStyles="Myriad Pro/32-120-semibold">
                            {heading}
                        </TextStyles>
                    )}
                    {subheading && (
                        <TextStyles textStyles={["Myriad Pro/16-140", null, null, null, "Myriad Pro/18-100"]}>
                            {subheading}
                        </TextStyles>
                    )}
                </Waterfall>

                <Waterfall rowGap={["12px", null, null, null, "16px"]}>
                    <NewsletterSignup
                        isFooter={isFooter}
                        emailInput={emailInput}
                        formStatus={form}
                        // setHeading={setHeading}
                    />

                    {!!consentText?.length && (
                        <Wysiwyg
                            data={consentText}
                            textComponent={(props) => <TextStyles textStyles="Myriad Pro/14-140" {...props} />}
                        />
                    )}
                </Waterfall>
            </Column>
        </Div>
    );
};

Newsletter.propTypes = {
    isFooter: PropTypes.bool,
    newsletter: PropTypes.object,
};

Newsletter.defaultProps = {
    isFooter: false,
    newsletter: {},
};

export default Newsletter;
